export default "__VITE_ASSET__Fb86SOKU__"